import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getAllAnfragen } from '../api/anfrageApi';
import Layout from '../components/Layout/Layout';
import { Loader2, Inbox } from '../icons/wp-icons';

export default function AnfragenIndex() {
  const [state, setState] = useState({ loading: true, targetId: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const anfragen = await getAllAnfragen();
        if (cancelled) return;
        const newest = Array.isArray(anfragen) && anfragen.length > 0
          ? [...anfragen].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0]
          : null;
        setState({ loading: false, targetId: newest?.id || null });
      } catch (e) {
        console.error('[AnfragenIndex] Laden fehlgeschlagen:', e);
        setState({ loading: false, targetId: null });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (state.loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-[60vh] text-text-muted">
          <Loader2 className="w-5 h-5 animate-spin" />
        </div>
      </Layout>
    );
  }

  if (state.targetId) {
    return <Navigate to={`/anfragen/${state.targetId}`} replace />;
  }

  return (
    <Layout>
      <div className="flex flex-col items-center justify-center h-[60vh] text-center px-4">
        <Inbox className="w-12 h-12 text-text-muted mb-3" />
        <h2 className="text-lg font-semibold">Noch keine Anfragen</h2>
        <p className="text-sm text-text-muted mt-1">
          Sobald eine Anfrage eingeht, landet sie direkt hier.
        </p>
      </div>
    </Layout>
  );
}
